import * as React from 'react';
import { IEurResult } from '../../../data/providers/reports/eurReportProvider';
import { Entity } from '../../../data/types';
import { formatDayFromUtc } from '../../../utils/date';
import { Row } from '../../layout/Row';
import { Metric } from '../../shared/Metric';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { DataWarning } from '../utils/DataWarning';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: IEurResult;
  pdfMode: EPdfMode;
  entity: Entity;
  shape: number[];
}

export const EurResult = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell>{props.result.displayDate}</DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.cmjStale && props.result.cmj ? (
            <DataWarning
              message={`The CMJs were performed on ${formatDayFromUtc(
                props.result.cmjDate
              )}`}
            />
          ) : null}
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.cmj}
            units={props.result.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.squatStale && props.result.squat ? (
            <DataWarning
              message={`The Squat Jumps were performed on ${formatDayFromUtc(
                props.result.squatDate
              )}`}
            />
          ) : null}
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.squat}
            units={props.result.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.eurStale && props.result.eur ? (
            <DataWarning message='The Squat Jump and the CMJ tests were not performed on the same day.' />
          ) : null}
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.eur}
            units=''
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[4] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.eurPercentageChange}
            units='%'
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[5] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.eurTotalChange}
            units=''
          />
        </DataCell>
      </DataColumn>
    </Row>
  );
};
